import PermissionsProvider from "./permissionsProvider";
import RestrictedWrapper from "./restrictedWrapper";
import { hasPermissions } from "./utils";
import PermissionContext from "./context";

export { RestrictedWrapper, hasPermissions, PermissionContext };

export default PermissionsProvider;
